var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconHeartUndo = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M24.6,6.9" }),
            React.createElement("path", { d: "M12.2,22.1l2.7,2.7,8.4-8.4,1.1-1.1c2.5-2.3,2.3-4.8.9-7" }),
            React.createElement("path", { d: "M21.2,5.1c-.8-.2-2.7-.5-5,1.8h0l-1.2,1.1-1.1-1.1c-2.3-2.4-6.1-2.4-8.4,0s-2.5,6.1-.2,8.4h0c0,.1,2.2,2.5,2.2,2.5" }),
            React.createElement("line", { x1: "2.5", y1: "27", x2: "27.3", y2: "2.9" }))));
});
export default IconHeartUndo;
//# sourceMappingURL=IconHeartUndo.js.map